import React from 'react';
import styled from 'styled-components';
import GatsbyImage from 'gatsby-image';
import { graphql, Link, useStaticQuery } from 'gatsby';

import { media } from '../../config/theme';
import Button from '../button/button';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin: auto;
  margin-top: 40px;
  margin-bottom: -40px;
`;

const Img = styled(GatsbyImage)`
  width: 100%;
  max-width: 600px;
  max-height: 80px;

  ${media.s`
    margin-bottom: 0;
    max-width: calc(100vw - 20px);
  `}
`;

const StyledButton = styled(Button)`
  a {
    display: block;
  }
`;

const EUBanner = () => {
  const {
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(query);

  return (
    <Wrapper>
      <Img fluid={fluid} imgStyle={{ objectFit: 'contain' }} />

      <div>
        <StyledButton
          component={Link}
          to="/dofinansowania"
          title="Informacje o dofinansowaniach"
        >
          Informacje o dofinansowaniach
        </StyledButton>
      </div>
    </Wrapper>
  );
};

const query = graphql`
  query {
    file(name: { eq: "baner-unii" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

export default EUBanner;
